import * as React from 'react';
import type { SpinnerProps } from '@components/atoms/spinner/types';
import type { ThemeProps } from '@models/types';
import { useTheme } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import styled from 'styled-components';

const Atom: React.FC<SpinnerProps> = ({ size, color, className, style, sx }) => {
    const theme = useTheme<ThemeProps>();

    return (
        <Stack spacing={2} direction='row' className={className} sx={sx} style={style}>
            <CircularProgress size={size} style={{ color: color || theme.palette.primaryA1 }} />
        </Stack>
    );
};

export const Spinner = styled(Atom)({});
